(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 50))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["namma-flowers-order"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.nfReady) return;
    const configNode = root.querySelector('[data-nf-config]');
    if (!configNode) return;
    const config = JSON.parse(configNode.textContent);
    root.dataset.nfReady = 'true';
    const t = config.strings;
    const products = config.products;
    const byId = new Map(products.map(p => [p.id, p]));
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const money = cents => new Intl.NumberFormat(config.locale || 'en', {style:'currency', currency:'EUR'}).format(cents / 100);
    const gross = p => Math.round(p.netCents * 119 / 100);
    const feeCents = Math.max(0, Math.round(Number(config.feeCents) || 0));
    const freeCents = Math.max(0, Math.round(Number(config.freeCents) || 0));
    const today = () => {
      const parts = new Intl.DateTimeFormat('en', {timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const find = type => parts.find(p => p.type === type).value;
      return `${find('year')}-${find('month')}-${find('day')}`;
    };
    const formatDate = date => new Intl.DateTimeFormat(config.locale || 'en', {day:'numeric',month:'long',year:'numeric'}).format(new Date(`${date}T12:00:00`));
    const wa = message => `https://wa.me/${String(config.whatsapp).replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;
    const storageKey = `namma-flowers-v2:${location.host}:${root.id}`;
    let quantities = {}, date = '', method = 'delivery', search = '', view = 'browse', message = '';
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (saved && typeof saved === 'object') {
        for (const [id,q] of Object.entries(saved.quantities || {})) if (byId.has(id) && Number.isSafeInteger(q) && q > 0) quantities[id] = q;
        if (typeof saved.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(saved.date) && saved.date >= today()) date = saved.date;
        if (saved.method === 'pickup') method = 'pickup';
      }
    } catch (_) {}
    const save = () => {try {localStorage.setItem(storageKey,JSON.stringify({quantities,date,method}));} catch (_) {}};
    const totals = () => {
      const lines = products.filter(p => quantities[p.id] > 0);
      const net = lines.reduce((sum,p) => sum + p.netCents * quantities[p.id], 0);
      const inclusive = lines.reduce((sum,p) => sum + gross(p) * quantities[p.id], 0);
      const shipping = !inclusive || method === 'pickup' || inclusive >= freeCents ? 0 : feeCents;
      return {lines,net,vat:inclusive-net,inclusive,shipping,total:inclusive+shipping,count:lines.reduce((sum,p)=>sum+quantities[p.id],0)};
    };
    const stepper = (p,q) => `<div class="nf__qty"><button type="button" data-nf-step="-1" data-nf-id="${esc(p.id)}" aria-label="${esc(t.decrease+' '+p.name+' '+p.variant)}">−</button><input type="number" inputmode="numeric" min="0" step="1" value="${q}" data-nf-quantity="${esc(p.id)}" aria-label="${esc(t.quantity+' '+p.name+' '+p.variant)}"><button type="button" data-nf-step="1" data-nf-id="${esc(p.id)}" aria-label="${esc(t.increase+' '+p.name+' '+p.variant)}">+</button></div>`;
    const controls = p => quantities[p.id] ? stepper(p,quantities[p.id]) : `<button type="button" class="nf__add" data-nf-step="1" data-nf-id="${esc(p.id)}" aria-label="${esc(t.add+' '+p.name+' '+p.variant)}">+ ${esc(t.add)}</button>`;
    function renderProducts() {
      const groups = ['loose','strings','leaves','garlands','rose'];
      const filtered = products.filter(p => `${p.name} ${p.variant} ${p.unit} ${t[p.category]}`.toLowerCase().includes(search.toLowerCase()));
      $('[data-nf-products]').innerHTML = filtered.length ? groups.map(category => {
        const group = filtered.filter(p => p.category === category);
        if (!group.length) return '';
        return `<section class="nf__group" data-nf-group="${category}"><h2>${esc(t[category])}<span>${esc(t.vat_included)}</span></h2><div class="nf__grid">${group.map(p=>`<article class="nf__row"><img class="nf__photo" src="${esc(p.image)}" alt="${esc(p.name)}" width="192" height="192" loading="lazy"><div class="nf__row-body"><h3>${esc(p.name)}${p.variant ? ' · '+esc(p.variant) : ''}</h3><div class="nf__unit">${esc(p.unit)}</div><div class="nf__row-bottom"><strong class="nf__price">${money(gross(p))}</strong><div data-nf-controls="${esc(p.id)}">${controls(p)}</div></div></div></article>`).join('')}</div></section>`;
      }).join('') : `<p class="nf__empty">${esc(t.no_results)}</p>`;
    }
    const breakdown = values => [
      [t.net_subtotal,money(values.net)],[t.product_vat,money(values.vat)],
      [t.products_total,money(values.inclusive)],
      [method==='pickup' ? t.pickup : t.shipping,values.shipping ? money(values.shipping) : t.free],
      [t.total,money(values.total)]
    ].map(([name,value])=>`<div class="nf__total-row"><span>${esc(name)}</span><span>${esc(value)}</span></div>`).join('');
    function updateTotals() {
      const values = totals();
      $('[data-nf-cart-title]').textContent = `${values.count} ${t.units} · ${money(values.total)}`;
      $('[data-nf-cart-hint]').textContent = `${t.vat_included} · ${method==='pickup' ? t.pickup+' '+t.free : t.shipping+' '+(values.shipping ? money(values.shipping) : t.free)}`;
      $('[data-nf-totals]').innerHTML = breakdown(values);
      $('[data-nf-review-date]').textContent = date ? `${t.required_date}: ${formatDate(date)}` : t.date_required;
      $('[data-nf-submit]').disabled = !values.lines.length;
      $('[data-nf-form]').hidden = !values.lines.length;
      save();
    }
    function renderLines() {
      const values = totals();
      $('[data-nf-lines]').innerHTML = values.lines.length ? values.lines.map(p=>`<article class="nf__line"><img class="nf__photo" src="${esc(p.image)}" alt="${esc(p.name)}" width="176" height="176" loading="lazy"><div><h3>${esc(p.name)}${p.variant ? ' · '+esc(p.variant) : ''}</h3><div class="nf__unit">${esc(p.unit)}</div>${stepper(p,quantities[p.id])}</div><div class="nf__line-price"><strong>${money(gross(p)*quantities[p.id])}</strong><button type="button" data-nf-remove="${esc(p.id)}">${esc(t.remove)}</button></div></article>`).join('') : `<div class="nf__empty"><p>${esc(t.empty)}</p><button class="nf__text" type="button" data-nf-action="browse">${esc(t.browse)} →</button></div>`;
      updateTotals();
    }
    function setQuantity(id,value,activeButton) {
      if (!byId.has(id)) return;
      const q = Math.max(0, Math.floor(Number(value) || 0));
      if (!Number.isSafeInteger(q)) return;
      if (q) quantities[id]=q; else delete quantities[id];
      $$(`[data-nf-controls="${id}"]`).forEach(el=>el.innerHTML=controls(byId.get(id)));
      if (view==='review') renderLines(); else updateTotals();
      if (activeButton && view==='browse') {
        const next=$(`[data-nf-controls="${id}"] [data-nf-step="${activeButton}"]`);
        if (next) next.focus({preventScroll:true});
      }
      $('[data-nf-status]').textContent=`${byId.get(id).name} ${byId.get(id).variant}: ${q}`;
    }
    function navigate(next) {
      view=next;
      $$('[data-nf-view]').forEach(el=>el.hidden=el.dataset.nfView!==next);
      $('[data-nf-cart]').hidden=next!=='browse';
      if (next==='review') renderLines();
      if (next==='browse') {renderProducts();updateTotals();}
      root.scrollIntoView({behavior:'auto',block:'start'});
      const focus=next==='browse' ? $('[data-nf-date]') : $(`[data-nf-view="${next}"]`);
      if (focus) focus.focus({preventScroll:true});
    }
    function fulfilment() {
      const delivery=method==='delivery';
      $('[data-nf-address]').hidden=!delivery;
      $('[data-nf-pickup]').hidden=delivery;
      for (const field of ['address','postcode','city']) {
        const el=$(`[name="${field}"]`);el.required=delivery;el.disabled=!delivery;
      }
      updateTotals();
    }
    function updateCustom() {
      $('[data-nf-custom]').href=wa(`${t.custom_message}${date ? '\n'+t.required_date+': '+formatDate(date) : ''}`);
    }
    const dateInput=$('[data-nf-date]');dateInput.min=today();dateInput.value=date;
    $(`[name="method"][value="${method}"]`).checked=true;
    $('[data-nf-shipping-hint]').textContent=`${t.shipping} ${money(feeCents)} · ${t.free} ${money(freeCents)}+ · ${t.pickup} ${t.free}`;
    dateInput.addEventListener('change',()=>{date=dateInput.value;updateTotals();updateCustom();});
    $('[data-nf-search]').addEventListener('input',e=>{search=e.target.value;renderProducts();});
    root.addEventListener('click',async event=>{
      const button=event.target.closest('button');if (!button || !root.contains(button)) return;
      if (button.dataset.nfStep) {const id=button.dataset.nfId;setQuantity(id,(quantities[id]||0)+Number(button.dataset.nfStep),button.dataset.nfStep);return;}
      if (button.dataset.nfRemove) {setQuantity(button.dataset.nfRemove,0);return;}
      if (button.dataset.nfCategory) {
        const category=button.dataset.nfCategory;
        $$('[data-nf-category]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        if (search) {search='';$('[data-nf-search]').value='';renderProducts();}
        if (category==='all') root.scrollIntoView({behavior:'smooth',block:'start'});
        else $(`[data-nf-group="${category}"]`).scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }
      switch (button.dataset.nfAction) {
        case 'review': navigate('review');break;
        case 'browse':navigate('browse');break;
        case 'top':root.scrollIntoView({behavior:'smooth',block:'start'});break;
        case 'copy':
          try {await navigator.clipboard.writeText(message);$('[data-nf-status]').classList.remove('nf__sr');$('[data-nf-status]').textContent=t.copied;}
          catch (_) {$('[data-nf-status]').classList.remove('nf__sr');$('[data-nf-status]').textContent=t.copy_failed;}
          break;
        case 'new': quantities={};date='';method='delivery';message='';search='';dateInput.value='';$('[data-nf-search]').value='';$('[data-nf-form]').reset();$('[data-nf-error]').hidden=true;$('[data-nf-lines]').innerHTML='';$('[data-nf-message]').textContent='';$('[data-nf-reference]').textContent='';$('[data-nf-whatsapp]').removeAttribute('href');$$('[data-nf-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.nfCategory==='all')));fulfilment();updateCustom();navigate('browse');break;
      }
    });
    root.addEventListener('change',event=>{
      if (event.target.dataset.nfQuantity) setQuantity(event.target.dataset.nfQuantity,event.target.value);
      if (event.target.name==='method') {method=event.target.value;fulfilment();}
    });
    $('[name="phone"]').addEventListener('input',event=>event.target.setCustomValidity(''));
    $('[data-nf-form]').addEventListener('submit',event=>{
      event.preventDefault();
      const values=totals();if (!values.lines.length) return;
      const error=$('[data-nf-error]');error.hidden=true;
      if (!date || date<today() || !dateInput.checkValidity()) {error.textContent=t.date_required;error.hidden=false;navigate('browse');dateInput.reportValidity();dateInput.focus();return;}
      const form=event.currentTarget, data=new FormData(form);
      const name=String(data.get('name')||'').trim(), phone=String(data.get('phone')||'').trim();
      if (!name) {form.elements.name.value='';form.elements.name.reportValidity();return;}
      const digits=phone.replace(/[^0-9]/g,'');
      if (!/^\+?[0-9\s().-]+$/.test(phone) || digits.length<8 || digits.length>15) {form.elements.phone.setCustomValidity(t.phone_invalid);form.elements.phone.reportValidity();return;}
      if (!form.reportValidity()) return;
      const reference='NF-'+new Date().toISOString().slice(0,10).replace(/-/g,'')+'-'+(globalThis.crypto && crypto.randomUUID ? crypto.randomUUID().slice(0,8).toUpperCase() : Math.random().toString(36).slice(2,10).toUpperCase());
      const time=String(data.get('time')),notes=String(data.get('notes')||'').trim();
      message=[`${t.message_title} · ${reference}`,'',...values.lines.map(p=>`${quantities[p.id]} × ${p.name}${p.variant ? ' · '+p.variant : ''} · ${p.unit} — ${money(gross(p)*quantities[p.id])} (${t.vat_included})`),'',`${t.net_subtotal}: ${money(values.net)}`,`${t.product_vat}: ${money(values.vat)}`,`${method==='pickup'?t.pickup:t.shipping}: ${money(values.shipping)}`,`${t.total} (${t.total_note}): ${money(values.total)}`,'',`${t.required_date}: ${formatDate(date)}`,`${t.required_time}: ${time} (${t.time_hint})`,`${t.customer}: ${name}`,`${t.phone}: ${phone}`,`${t.fulfilment}: ${method==='pickup'?t.pickup_hint:t.delivery}`,...(method==='delivery'?[`${t.address}: ${String(data.get('address')).trim()}, ${data.get('postcode')} ${String(data.get('city')).trim()}, Germany`]:[]),`${t.special}: ${notes||t.none}`,'',t.policy].join('\n');
      $('[data-nf-reference]').textContent=reference;
      $('[data-nf-confirm-totals]').innerHTML=breakdown(values);
      $('[data-nf-message]').textContent=message;
      $('[data-nf-whatsapp]').href=wa(message);
      navigate('confirmation');
    });
    renderProducts();fulfilment();updateCustom();
  }
  const init=scope=>scope.querySelectorAll('[data-namma-flowers]').forEach(setup);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              const   swiperItems = document.querySelectorAll('.product-recommendations'),
              sliderOptions = $(swiperItems).attr('data-slider-options'),
               slideroptionConfig = $.parseJSON(sliderOptions);
               $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/embed/loader.js"); 
              this.innerHTML = recommendations.innerHTML;
              var recommedndationSlider = new Swiper(".product-recommendations", slideroptionConfig);
              window.initSwatchOptionImage();
              window.initVariantChanger(this);
              window.initTooltips([].slice.call(this.querySelectorAll('[data-bs-toggle="tooltip"]')));
              window.initCompare();
            }
    
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["textiles-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nm-fashion]').forEach(function(section){
    section.querySelectorAll('[data-finder-group]').forEach(function(group){
      group.querySelectorAll('button').forEach(function(button){
        button.addEventListener('click',function(){
          group.querySelectorAll('button').forEach(function(item){item.classList.remove('is-active')});
          button.classList.add('is-active');
          var occasion=section.querySelector('[data-finder-group="occasion"] .is-active').dataset.value;
          var audience=section.querySelector('[data-finder-group="audience"] .is-active').dataset.value;
          section.querySelector('[data-match-link]').setAttribute('aria-label','Show '+occasion+' looks for '+audience);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
